import React from 'react';
import { RouteConfigComponentProps, renderRoutes } from 'react-router-config';

const Shipping = ({ route }: RouteConfigComponentProps) => {
  return <div>{renderRoutes(route?.routes)}</div>;
};

export default Shipping;
